import { Image } from "@tiptap/extension-image";
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react";
import theme from "../../../../styles/colors";
import ImageComponent, { IMAGE_DELETE_EVENT } from "./ImageComponent";
import "./Spinner.css";

const CustomImage = Image.extend({
  name: "image",
  group: "block",
  inline: false,
  draggable: true,

  addAttributes() {
    return {
      src: {},
      alt: { default: null },
      caption: { default: "" },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageComponent);
  },
  addKeyboardShortcuts() {
    const requestDelete = (editor) => {
      const { selection } = editor.state;
      if (selection.node?.type.name !== this.name) {
        return false;
      }
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent(IMAGE_DELETE_EVENT, {
            detail: { pos: selection.from },
          }),
        );
      }
      return true;
    };
    return {
      Backspace: ({ editor }) => requestDelete(editor),
      Delete: ({ editor }) => requestDelete(editor),
    };
  },
  renderHTML({ HTMLAttributes }) {
    const style = {
      container: `
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        border: 2px solid rgb(${theme.colors.neutral150});
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        margin: 16px 0px;
      `,
      imageWrapper: `
        aspect-ratio: 2 / 1;
        // border-radius: 12px;
        overflow: hidden;
      `,
      image: `
        background-image: url(${HTMLAttributes.src
          .replaceAll("(", "%28")
          .replaceAll(")", "%29")});
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        position: relative;
        background-color: rgb(${theme.colors.offWhite});
      `,
      overlay: `
        background-color: rgba(${theme.colors.neutral100}, 0.2);
        backdrop-filter: blur(32px);
        position: absolute;
        inset: 0;
        background-image: inherit;
        background-size: cover;
        filter: blur(32px);
        transform: scale(1.2);
      `,
      textContainer: `
        background: rgb(${theme.colors.lgtGrey});
        padding: 12px;
        height: auto;
      `,
      text: `
        font-family: Inter;
        font-size: 17px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0em;
        text-align: left;
        color: rgb(${theme.colors.neutral200});
      `,
    };

    return [
      "div",
      mergeAttributes({ style: style.container }),
      [
        "div",
        mergeAttributes({ style: style.imageWrapper }),
        [
          "div",
          mergeAttributes(HTMLAttributes, { style: style.image }),
          ["div", mergeAttributes({ style: style.overlay })],
          [
            "div",
            mergeAttributes(HTMLAttributes, {
              style: `background-image: url(${HTMLAttributes.src
                .replaceAll("(", "%28")
                .replaceAll(")", "%29")});
              background-position: center;
              background-size: contain;
              background-repeat: no-repeat;
              position: absolute;
              display: block;
              inset: 0;
              border-bottom: ${
                HTMLAttributes.caption
                  ? `2px solid rgb(${theme.colors.neutral150})`
                  : ""
              };
              `,
            }),
          ],
        ],
        "",
      ],
      HTMLAttributes.caption && [
        "div",
        mergeAttributes({ style: style.textContainer }),
        [
          "span",
          mergeAttributes({ style: style.text }),
          HTMLAttributes.caption,
        ],
      ],
    ];
  },
});

export default CustomImage;
